import React, { useEffect, useRef } from 'react';
import './CatalogueMobileWhy.css';

const CatalogueMobileWhy = () => {
    const bubbles = [
        { id: 1, text1: "Faster buyer", text2: "understanding" },
        { id: 2, text1: "Better", text2: "engagement", text3: "at stalls" },
        { id: 3, text1: "Premium", text2: "brand", text3: "perception" },
        { id: 4, text1: "Shorter sales", text2: "conversations" }
    ];

    const sectionRef = useRef(null);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('revealed');
                }
            });
        }, observerOptions);

        const elements = sectionRef.current.querySelectorAll('.scroll-reveal');
        elements.forEach(el => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <div className="catalogue-why-container" ref={sectionRef}>
            <div className="catalogue-why-bg-overlay"></div>

            <h1 className="catalogue-why-title scroll-reveal">
                Why <span className="catalogue-title-highlight">DEVELOPERS</span> use <span className="catalogue-title-highlight">SPATIAL CATALOGUE</span>
            </h1>

            <div className="catalogue-bubbles-grid">
                {bubbles.map((bubble, index) => (
                    <div
                        key={bubble.id}
                        className={`catalogue-bubble catalogue-bubble-${bubble.id} scroll-reveal bubble-reveal`}
                        style={{ transitionDelay: `${index * 0.15}s` }}
                    >
                        <div className="catalogue-bubble-content">
                            <span>{bubble.text1}</span>
                            <span>{bubble.text2}</span>
                            {bubble.text3 && <span>{bubble.text3}</span>}
                        </div>
                    </div>
                ))}
            </div>

            <div className="catalogue-why-footer scroll-reveal">
                <p className="catalogue-footer-quote">
                    "EXPERIENCE THE FUTURE OF<br />
                    PROPERTY SALES — TODAY."
                </p>
            </div>
        </div>
    );
};

export default CatalogueMobileWhy;
